__turbopack_context__.v({
  "footer": "footer-module__H_cfiG__footer",
});
